import styled from 'styled-components';
const ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
const ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
const DIRECTION_OPTIONS = {
  column: 'column',
  row: '',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse'
};
const JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};
const WRAP_OPTIONS = {
  nowrap: '',
  wrap: 'wrap'
};
const Flex = styled.div.withConfig({
  displayName: "Flex",
  componentId: "lo2z7z-0"
})(["align-items:", ";align-self:", ";display:flex;flex-direction:", ";flex-grow:1;flex-wrap:", ";justify-content:", ";max-width:100%;width:100%;"], props => ALIGN_OPTIONS[props.align], props => ALIGN_SELF_OPTIONS[props.alignSelf], props => DIRECTION_OPTIONS[props.direction], props => WRAP_OPTIONS[props.wrap], props => JUSTIFY_OPTIONS[props.justify]);
export default Flex;